import { render } from "./PaddleCheckout.vue?vue&type=template&id=4079411c&scoped=true"
import script from "./PaddleCheckout.vue?vue&type=script&lang=js"
export * from "./PaddleCheckout.vue?vue&type=script&lang=js"

import "./PaddleCheckout.vue?vue&type=style&index=0&id=4079411c&scoped=true&lang=css"

import exportComponent from "/Users/emperinter/app/HTML/watermark-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4079411c"]])

export default __exports__